module.exports = [
  require('./list/chromatic_dragon_spirit_2021_04_14'),
  require('./list/gem_dragon_spirit_2021_04_14'),
  require('./list/metallic_dragon_spirit_2021_04_14'),
]
